import {Log} from "../service/log/model/log";

export class LogsSort{
    
    static compareFn(a: Log, b: Log): number{
        if (a.time < b.time) {
            return 1;
        }
        if (a.time > b.time) {
            return -1;
        }
        return 0;
    }
    
}

